module.exports = __webpack_public_path__ + "img/edge_patrimoine_fontaine.a1cb7883.svg";